var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgTamanhoM = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m39 75.75-29.52-.09c-2.272 0-4.118-1.799-4.118-4.012V34.852c0-2.213 1.846-4.012 4.117-4.012H37.02c2.272 0 4.117 1.799 4.117 4.012V74.25"
  }), React.createElement("path", {
    fill: color,
    d: "M40.5 36.75H6v-3l.75-1.5 2.31-.75h29.19l1.5.75.75 1.5v3ZM6 71.25V69h23.25v6.6H10.875c-1.805 0-4.125-1.35-4.125-1.35L6 73.5v-2.25Z"
  }), React.createElement("path", {
    stroke: color,
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M40.5 36.75H6v-3l.75-1.5 2.31-.75h29.19l1.5.75.75 1.5v3ZM6 71.25V69h23.25v6.6H10.875c-1.805 0-4.125-1.35-4.125-1.35L6 73.5v-2.25Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M29.25 75.66H9.48c-2.272 0-4.118-1.799-4.118-4.012V34.852c0-2.213 1.846-4.012 4.117-4.012H37.02c2.272 0 4.117 1.799 4.117 4.012v7.898M5.362 36.924h35.775"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M21.83 72.505h2.84"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M6 69h23.25"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-80)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m16.5 55.666 12.072-5.286M16.5 51.524 24.26 48"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M45.36 23.783a8.252 8.252 0 0 1-1.927-3.493 8.211 8.211 0 0 1 2.412-8.236c1.45-1.258 3.414-2.41 6.116-3.133 8.758-2.347 12.53 2.005 22.933-.782.175-.047.335-.083.488-.114h.001l2.358 8.798h-.001c-.149.05-.305.1-.48.147-23.4 6.27-5.55 20.335-12.183 23.104-1.927.805-3.782-.61-4.898-4.776-2.424-9.047-9.895-6.735-14.819-11.515Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m75 18-2.25-9 3-.75L78 16.5 75 18Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M84.347 6.557c-2.004 3.268-4.06-1.524-5.896 1.58M85.276 10.03c-2.004 3.266-4.06-1.525-5.896 1.579M86.223 13.556c-2.004 3.268-4.06-1.524-5.896 1.58M72.526 8.675l2.408 8.987"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M55.926 11.662c2.186-.253 4.063-.07 5.944.175"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M52.349 22.331c2.243-.6 3.568-2.932 2.959-5.206-.61-2.275-2.923-3.632-5.166-3.03-2.244.6-3.568 2.932-2.959 5.206.61 2.275 2.922 3.631 5.166 3.03Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M45.36 23.783a8.252 8.252 0 0 1-1.927-3.493 8.211 8.211 0 0 1 2.412-8.236c1.45-1.258 3.414-2.41 6.116-3.133 8.758-2.347 12.53 2.005 22.933-.782.175-.047.335-.083.488-.114h.001l2.358 8.798h-.001c-.149.05-.305.1-.48.147-23.4 6.27-5.55 20.335-12.183 23.104-1.927.805-3.782-.61-4.898-4.776-2.424-9.047-9.895-6.735-14.819-11.515Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m26.907 83.366 5.387-6.317V50.733c0-2.523 1.941-4.564 4.342-4.564h39.22c2.4 0 4.341 2.04 4.341 4.565v26.315l5.387 6.317"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m26.907 83.366 5.387-6.317V50.733c0-2.523 1.941-4.564 4.342-4.564h39.22c2.4 0 4.341 2.04 4.341 4.565v26.315l5.387 6.317"
  }), React.createElement("path", {
    fill: color,
    d: "M79.903 52.25H32.595v-2.417l.789-2.416 2.365-1.611h37.846l3.942.805 2.366 2.417v3.222Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "m32.596 77.222-4.73 5.64h56.769l-3.943-5.64H32.596Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M27.02 83.343h58.462c.23 0 .407.195.407.429v1.316c0 1.239-.955 2.244-2.134 2.244H28.746c-1.178 0-2.134-1.005-2.134-2.244V83.78c0-.242.186-.429.408-.429v-.008Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M55.354 49.261h1.793"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M32.301 52.222h47.896M32.302 77.064h47.896"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M55.354 80.406h1.193M59.54 80.406h1.2M46.966 80.406h1.2M51.16 80.406h1.2M42.78 80.406h1.193M34.4 80.406h1.192M38.585 80.406h1.2M72.714 80.406h1.2M76.909 80.406h1.193M68.528 80.406h1.193"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-80)",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M46 69.166 68.078 59.5M46 64.334l14.193-6.445"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m26.907 83.366 5.387-6.317V50.733c0-2.523 1.941-4.564 4.342-4.564h39.22c2.4 0 4.341 2.04 4.341 4.565v26.315l5.387 6.317"
  }));
};
export default SvgTamanhoM;